import cn from "classnames";
import React from "react";
import LiquiditySelect from "../LiquiditySelect/LiquiditySelect";
const LiquidityCard = ({
  cardName,
  dropdownRef,
  setIsOpen,
  isOpen,
  tokens,
  selectedToken,
  handleTokenChange,
  getFormattedBalance,
  formatBalanceForPrice,
  safeParseNumber,
  tokenValue,
  pricemap,
  changeTokenValue,
  setNewMax,
  connectedAccount,
  isInsufficientBalance,
  setMainActiveSection,
  paletteMode,
}) => {
  return (
    <article
      className={
        "border border-deepBlue rounded-lg items-center pt-4 pb-6 w-full"
      }
    >
      <div className="w-full">
        <div className="px-6 md:px-8 pb-4 border-b border-lightBlue dark:border-darkSlateBlue ">
          <div className="flex justify-between items-center mb-3">
            <h3
              className={
                "leading-6 text-base font-medium text-black dark:text-white"
              }
            >
              {cardName}
            </h3>

            {isInsufficientBalance && connectedAccount && (
              <div className="flex justify-between gap-1">
                <p className="text-fadedRed text-sm">Insufficient Balance.</p>
                <button
                  type="button"
                  className={cn("text-fadedRed text-sm")}
                  onClick={() => {
                    setMainActiveSection(1);
                  }}
                >
                  <span className="underline cursor-pointer">Swap Now</span>
                </button>
              </div>
            )}
          </div>
          <div>
            <LiquiditySelect
              dropDownRef={dropdownRef}
              setIsOpen={setIsOpen}
              isOpen={isOpen}
              tokens={tokens}
              selectedToken={selectedToken}
              tokenValue={tokenValue}
              changeTokenValue={changeTokenValue}
              handleTokenChange={handleTokenChange}
              setNewMax={setNewMax}
              cardName={cardName}
              paletteMode={paletteMode}
            />
          </div>
        </div>
        <div className="w-full px-6 md:px-8 pt-3 flex flex-col gap-1 md:flex-row md:justify-between md:gap-0">
          {/* Token Balance */}

          <div className={"flex items-center gap-2 items-center"}>
            <p className="text-semiBlack text-xs md:text-sm leading-[14.4px] md:leading-4 dark:text-semiWhite">
              Balance
            </p>
            <span className="flex-1 bg-lightGrayBlue h-[1px]  dark:bg-darkSlateBlue md:hidden" />
            <p className="text-black text-xs md:text-sm leading-6 dark:text-white">{`${
              getFormattedBalance(selectedToken.name) === "0"
                ? "00.00"
                : getFormattedBalance(selectedToken.name)
            } ${selectedToken.name}`}</p>
          </div>

          <p
            className={
              "text-semiBlack flex items-center gap-2 text-xs md:text-sm leading-[14.4px] dark:text-semiWhite"
            }
          >
            <p>Amount in USD</p>
            <span className="flex-1 bg-lightGrayBlue h-[1px]  dark:bg-darkSlateBlue md:hidden" />
            <p className="text-[#000] text-xs md:text-sm leading-6 dark:text-white">
              ≈
              {formatBalanceForPrice(
                safeParseNumber(tokenValue) *
                  safeParseNumber(pricemap[selectedToken.name])
              ) === "0"
                ? "00.00"
                : formatBalanceForPrice(
                    safeParseNumber(tokenValue) *
                      safeParseNumber(pricemap[selectedToken.name])
                  )}
              $
            </p>
          </p>
        </div>
      </div>
    </article>
  );
};

export default LiquidityCard;
